import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './layout';
import Home from './pages/home';
import AboutPage from './pages/about';
import NoPage from './pages/404';
import ServicesPage from './pages/services';
import BoardMembers from './pages/team/BoardMembers';
import BlogPage from './pages/blog/blog';
import BlogItem from './pages/blog/single-blog';
import ContactPage from './pages/contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="board-members" element={<BoardMembers />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:id" element={<BlogItem />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
